import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import DiscountForm from './DiscountForm.vue';
import { useForm } from '@/util/useForm';
import NModel from '@/component/NModel/NModel.vue';
import moment from 'moment';
import EditableCell from '@/component/editable-cell.vue';
import router, { useRoute } from '@/router';
import GoodsTable from './GoodsTable.vue';
import {
  editDiscount,
  editProductSort,
  getEditProductList,
  removeProduct,
  addProduct,
  removeDiscount,
  getEditDetail,
} from '@/api/marketing/discount';
import { message } from 'ant-design-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EditDiscount',
  setup(__props) {

const isEdit = ref<boolean>(true);
const visible = ref<boolean>(false);
const route = useRoute();
const DiscountFormRef = ref<any>(null);
const formVal = ref<any>(); // 表单信息
const selectedRowKeys = ref<any[]>([]); // 选中
const isShowDelete = ref<boolean>(false);
const dataSource = ref<any[]>([]); // 表格数据
const loading = ref<boolean>(false); // 表格加载
const form = useForm(); // 表单
const queryParams = ref<any>({}); // 搜索条件
const isAllSelected = ref<boolean>(false); // 全选
const sort_plf_stock = ref<number | undefined>(); // 排序
const isShowStop = ref<boolean>(false); // 停用确认框
const pagination = ref({
  current: 1,
  total: 1,
  limit: 10,
});
const editValue = ref<any>({}); // 编辑-值
// 搜索
async function queryGoods() {
  const { product_id, product_name, is_show } = form.value.getFormValue();
  queryParams.value = {
    discounts_id: route.query.id,
    product_id,
    product_name,
    is_show,
    sort_plf_stock,
  };
  query({
    current: pagination.value.current,
    limit: pagination.value.limit,
    ...queryParams.value,
  });
}
async function query(params = queryParams.value) {
  const formatParams = {
    current: pagination.value.current,
    limit: pagination.value.limit,
    ...params,
  };
  loading.value = true;
  dataSource.value = [];
  const res: any = await getEditProductList(formatParams);
  loading.value = false;
  pagination.value = {
    current: res?.data?.current,
    total: res?.data?.total,
    limit: res?.data?.limit,
  };
  dataSource.value = res?.data.detail;
}
// 清除搜索条件
function clear() {
  form.value.resetFields();
  queryParams.value = {};
  queryGoods();
  selectedRowKeys.value = [];
  isAllSelected.value = false;
}
// 保存
async function onSaveEdit() {
  DiscountFormRef.value.getFormData();
  const send_data = {
    name: formVal.value.name,
    type: formVal.value.type,
    superposition: formVal.value.overlay,
    threshold_price: formVal.value.threshold_price,
    discounts_minus: formVal.value.type == 1 ? formVal.value.discounts_minus : '',
    discounts_ratio: formVal.value.type == 2 ? formVal.value.discounts_ratio : '',
    start_time: formVal.value.start_time,
    end_time: formVal.value.end_time,
  };
  const res = await editDiscount(editValue.value.id, send_data);
  if (res.status !== 200) {
    message.error((res as any).message);
    return;
  }
  message.success('保存成功');
  isEdit.value = true;
  router.replace('/marketing/discount');
}
// 换页
function onChangePage(page) {
  pagination.value.current = page;
  query({ ...queryParams.value, current: pagination.value.current, limit: pagination.value.limit });
  selectedRowKeys.value = [];
  isAllSelected.value = false;
}
// 全选框
function onSelectAllRows(e) {
  isAllSelected.value = e.target.checked;
  if (isAllSelected.value) {
    selectedRowKeys.value = dataSource.value?.map(item => item.id);
  } else {
    selectedRowKeys.value = [];
  }
}
// 删除
async function onRemoveProduct(record) {
  const res: any = await removeProduct(route.query.id, { id_list: [record.id] });
  if (res.data == 0) {
    return message.error('删除失败');
  }
  message.success('删除成功');
  selectedRowKeys.value = [];
  query();
  setTimeout(() => {
    if (dataSource.value.length == 0 && editValue.value.status !== 3) {
      isShowStop.value = true;
    }
  }, 500);
}
// 批量操作-删除
function handleMenuClick(e) {
  if (e.key == '1' && selectedRowKeys.value.length < 1) {
    message.error('请勾选标签');
    return;
  }
  isShowDelete.value = true;
}
// 批量删除确认
async function deleteOk() {
  const res: any = await removeProduct(editValue.value.id, { id_list: selectedRowKeys.value });
  if (res.data == 0) {
    return message.error('删除失败');
  }
  message.success('批量删除成功');
  selectedRowKeys.value = [];
  isShowDelete.value = false;
  query();
  setTimeout(() => {
    if (dataSource.value.length == 0 && editValue.value.status !== 3) {
      isShowStop.value = true;
    }
  }, 500);
  isAllSelected.value = false;
}
// 编辑排序值
async function handleSortChange(id: number, value: number) {
  if (value === null) {
    message.error('修改失败');
    return;
  }
  if (!/^[0-9]+$/.test(value + '')) {
    message.error('排序值须为>=0的整数值！');
    return;
  }
  const res: any = await editProductSort(id, value);
  if (res.status !== 200) {
    return message.error(res.message);
  }
  message.success('修改成功');
  query();
}
// 获取form表单信息
function getVal(val) {
  formVal.value = val;
}
// 表格改变-排序
function onTableChange({ current }, filters, sorter) {
  const sort: any = sorter.order; // 排序类型，正序/倒序/不排序
  if (sort == 'ascend') {
    sort_plf_stock.value = 2;
  } else if (sort == 'descend') {
    sort_plf_stock.value = 1;
  } else {
    sort_plf_stock.value = undefined;
  }
  query({ ...queryParams.value, current });
}
// 选中表格
function onSelectChange(selectedRow) {
  selectedRowKeys.value = selectedRow;
  if (selectedRowKeys.value.length == dataSource.value.length) {
    isAllSelected.value = true;
  } else {
    isAllSelected.value = false;
  }
}
// 添加商品
async function getGoodData(val) {
  const product_list = val.map(({ id, sort }) => ({ id, sort }));
  const send_data = {
    discounts_id: editValue.value.id,
    product_list: product_list,
  };
  const res: any = await addProduct(send_data);
  if (res.status !== 200) {
    visible.value = false;
    return message.error(res.message);
  }
  message.success('添加成功');
  visible.value = false;
  query();
}
// 改变每页显示条目
function onShowSizeChange(current, pageSize) {
  pagination.value.limit = pageSize;
  query({ ...queryParams.value, current: 1 });
}

// 停用确认
async function stopOk() {
  const res: any = await removeDiscount(editValue.value.id);
  if (res.status == 200) {
    message.success('停用成功');
    isShowStop.value = false;
    router.push('/marketing/discount');
  } else {
    message.error(res?.message);
    isShowStop.value = false;
  }
}
function Format(time) {
  return moment(time * 1000).format('YYYY-MM-DD HH:mm:ss');
}
// 返回
function onGoBack() {
  router.replace('/marketing/discount');
}
// 获取路由携带参数
onMounted(async () => {
  const res = await getEditDetail({ id: route.query.id });
  // editValue.value = route.query.value;
  editValue.value = res.data;
  queryGoods();
});

return { __sfc: true,isEdit, visible, route, DiscountFormRef, formVal, selectedRowKeys, isShowDelete, dataSource, loading, form, queryParams, isAllSelected, sort_plf_stock, isShowStop, pagination, editValue, queryGoods, query, clear, onSaveEdit, onChangePage, onSelectAllRows, onRemoveProduct, handleMenuClick, deleteOk, handleSortChange, getVal, onTableChange, onSelectChange, getGoodData, onShowSizeChange, stopOk, Format, onGoBack, DiscountForm, NModel, EditableCell, GoodsTable }
}

})